import { render, staticRenderFns } from "./LoadOnDemand.vue?vue&type=template&id=3303f052&scoped=true&"
import script from "./LoadOnDemand.vue?vue&type=script&lang=js&"
export * from "./LoadOnDemand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3303f052",
  null
  
)

export default component.exports